import { Grid, Typography } from '@mui/material';
import FormCheckboxPdf from '../../../common/Forms/FormCheckboxPdf';
import FormTextFieldPdf from '../../../common/Forms/FormTextFieldPdf';

export const CheckboxGridItems = ({ heading, data, text }) => (
  <>
    <Grid item md={2} sm={2} xs={2}>
      {heading}
    </Grid>
    <Grid item md={10} sm={10} xs={10}>
      {text}
      {data.map((item, index) => (
        <FormCheckboxPdf key={index} item={item} />
      ))}
    </Grid>
  </>
);

export const InputFieldGridItems = ({ heading, value, text }) => {
  return (
    <>
      <Grid item md={2} sm={2} xs={2}>
        {heading}
      </Grid>
      <Grid item md={10} sm={10} xs={10}>
        {text}
        <FormTextFieldPdf defaultValue={value} />
      </Grid>
    </>
  );
};

export const ClientDetails = ({ data }) => {
  return (
    <>
      {data.map((item, index) => (
        <Grid key={index} item xs={12}>
          {`${item.label} : ${item.value}`}
        </Grid>
      ))}
    </>
  );
};

export const CalOMSAdmitHeading = ({ title }) => {
  return (
    <>
      <Grid item>
        <Typography variant="h4">{title}</Typography>
      </Grid>
    </>
  );
};

export const CalOMSAdmitSubHeading = ({ title }) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5">{title}</Typography>
      </Grid>
    </>
  );
};

export const CheckboxGridItemsWithField = ({ heading, data, text, value }) => (
  <>
    <Grid item md={2} sm={2} xs={2}>
      {heading}
    </Grid>
    <Grid item md={10} sm={10} xs={10}>
      {text}
      <FormTextFieldPdf defaultValue={value} />
      {data.map((item, index) => (
        <FormCheckboxPdf key={index} item={item} />
      ))}
    </Grid>
  </>
);

export const getCheckboxItems = (data, checkedValue) =>
  data.map((item, index) => ({
    ...item,
    checked: checkedValue === index,
  }));

  const isValueEmpty = (value) =>
    value === '' || value === null || value === undefined;

  export const getYesNoCheckBox = (getYesNo, clientInfoKey) => {
    const isClientInfoValueEmpty = isValueEmpty(clientInfoKey);

    return getYesNo?.map((getYesNo, index) => ({
      ...getYesNo,
      checked: isClientInfoValueEmpty
        ? false
        : clientInfoKey === index
        ? false
        : true,
    }));
  };

  const clientInfoValueIndexMapping = {
    1: { 0: true },
    0: { 1: true },
    2: { 2: true },
  };

  export const getNotSureYesNoCheckBox = (options, clientInfoKey) => {
    const isClientInfoValueEmpty = isValueEmpty(clientInfoKey);

    return options?.map((option, index) => ({
      ...option,
      checked: isClientInfoValueEmpty
        ? false
        : clientInfoValueIndexMapping[clientInfoKey]?.[index],
    }));
  };